// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"14":"685ed57b","15":"7951d031","331":"66159d4f","465":"06ee1276","806":"d65f40f4","855":"d5dad2fb","966":"07ffc10c"}[chunkId] + ".js";
};